<template>
<div :class="['history', disabled ? 'disabled' : '']" @click="emitClick">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99996 1.14307C6.24206 1.14808 4.55321 1.82804 3.28225 3.04249V1.82878C3.28225 1.64692 3.21001 1.4725 3.08141 1.34391C2.95281 1.21531 2.7784 1.14307 2.59654 1.14307C2.41467 1.14307 2.24026 1.21531 2.11166 1.34391C1.98307 1.4725 1.91082 1.64692 1.91082 1.82878V4.91449C1.91082 5.09636 1.98307 5.27077 2.11166 5.39937C2.24026 5.52796 2.41467 5.60021 2.59654 5.60021H5.68225C5.86411 5.60021 6.03853 5.52796 6.16712 5.39937C6.29572 5.27077 6.36796 5.09636 6.36796 4.91449C6.36796 4.73263 6.29572 4.55822 6.16712 4.42962C6.03853 4.30102 5.86411 4.22878 5.68225 4.22878H4.03654C4.91821 3.30743 6.09334 2.72203 7.35987 2.57324C8.62641 2.42445 9.90521 2.72156 10.9764 3.4135C12.0476 4.10543 12.8443 5.14895 13.2294 6.36464C13.6146 7.58032 13.5642 8.89222 13.0869 10.0748C12.6096 11.2573 11.7352 12.2366 10.614 12.8443C9.49287 13.452 8.19504 13.6501 6.94366 13.4045C5.69228 13.159 4.56554 12.4852 3.75717 11.4989C2.9488 10.5126 2.5093 9.27544 2.51425 8.00021C2.51425 7.81835 2.44201 7.64393 2.31341 7.51533C2.18481 7.38674 2.0104 7.31449 1.82854 7.31449C1.64667 7.31449 1.47226 7.38674 1.34366 7.51533C1.21507 7.64393 1.14282 7.81835 1.14282 8.00021C1.14282 9.35642 1.54499 10.6822 2.29846 11.8098C3.05193 12.9375 4.12287 13.8164 5.37585 14.3354C6.62883 14.8544 8.00757 14.9902 9.33773 14.7256C10.6679 14.461 11.8897 13.8079 12.8487 12.8489C13.8077 11.89 14.4608 10.6681 14.7253 9.33797C14.9899 8.00781 14.8541 6.62907 14.3351 5.37609C13.8161 4.12311 12.9372 3.05218 11.8096 2.2987C10.6819 1.54523 9.35618 1.14307 7.99996 1.14307ZM7.99996 5.25735C7.8181 5.25735 7.64369 5.3296 7.51509 5.45819C7.38649 5.58679 7.31425 5.7612 7.31425 5.94307V8.00021C7.31425 8.18207 7.38649 8.35648 7.51509 8.48508C7.64369 8.61368 7.8181 8.68592 7.99996 8.68592H9.37139C9.55325 8.68592 9.72767 8.61368 9.85627 8.48508C9.98486 8.35648 10.0571 8.18207 10.0571 8.00021C10.0571 7.81835 9.98486 7.64393 9.85627 7.51533C9.72767 7.38674 9.55325 7.31449 9.37139 7.31449H8.68568V5.94307C8.68568 5.7612 8.61343 5.58679 8.48484 5.45819C8.35624 5.3296 8.18183 5.25735 7.99996 5.25735Z" :fill="!themeStatus ? '#6750A4' : '#FFFFFF'"/>
    </svg>

</div>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: "HistoryButton",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState(['themeStatus']),
        },
        methods: {
            emitClick () {
                this.$emit('click')
            }
        }
    }
</script>
<style scoped lang="scss">
.history {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--new-front-main-bg);
  border: 1px solid #744DB2;
    border-radius: 10px;
  transition: background .2s ease;
    cursor: pointer;
  &:hover {
    background: var(--new-front-bg-btn-secondary-bg-modal-primary-hover);
  }
}
.disabled {
    opacity: .5;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
